import React, { useContext } from 'react';
import { IGetCountries, UserRoles } from 'types';
import { useRoleAccess } from 'hooks/useRoleAccess';
import { useFetchData } from 'hooks/useFetchData';
import { getCountries } from 'backend/additionalInformation';
import { IRestaurantsContext, RestaurantsContext } from '../../../restaurantsState/restaurantsContext';
import OutsideFormSelect from 'components/Select/OutsideFormSelect';
import style from './CountrySelect.module.scss';

const CountrySelect: React.FC = () => {
	const { setIDCountry, IDSelectedCountry } = useContext<IRestaurantsContext>(RestaurantsContext);
	const hasAccess = useRoleAccess([
		UserRoles.SUPER_USER,
		UserRoles.CLIENT_MANAGER,
		UserRoles.GROUP_MANAGER,
		UserRoles.TECHNICAL,
	]);
	const { response, loading, refetch, responseError } = useFetchData<IGetCountries, null>(
		hasAccess ? getCountries : null,
	);

	const value = !loading ? IDSelectedCountry : undefined;

	const handleSelect = (value: string) => {
		setIDCountry(value);
	};

	return (
		<OutsideFormSelect
			containerClassName={style.container}
			className={style.select}
			testId="CountrySelect"
			name="CountrySelect"
			label="countryLabel"
			onChange={handleSelect}
			onRefetch={refetch}
			value={value}
			options={response?.data.countries}
			listItemHeight={response?.data.countries.length}
			disabled={!hasAccess || loading}
			loading={loading}
			fetchError={responseError}
			withValidation={false}
		/>
	);
};

export default CountrySelect;
